// extracted by extract-css-chunks-webpack-plugin
module.exports = {"newText":"hmUHhm","sparkle":"_1wZKcQ"};